import React from "react";
import ModalConfirm from "../../common/components/ModalConfirm";

const ModalConfirmLogin = (props) => {
  const { onConfirm, handleClose, open } = props;
  return (
    <ModalConfirm
      title="common.bottombar.notification"
      content="content.modal.confirm.login"
      onConfirm={onConfirm}
      onCancel={handleClose}
      textConfirm="text.btn.modal.confirm.login"
      handleClose={handleClose}
      open={open}
      styles={undefined}
      classBtnConfirm="bg-primary text-white text-[13px] rounded-lg font-medium focus:outline-none text-white focus:ring-4 focus:ring-yellow-300 px-5 py-2.5 mr-2 mb-2 dark:focus:ring-yellow-900"
    />
  );
};
export default ModalConfirmLogin;
